module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page-actionsheet"
  }, [_c('h1', {
    staticClass: "page-title"
  }, [_vm._v("Action Sheet")]), _vm._v(" "), _c('div', {
    staticClass: "page-actionsheet-wrapper"
  }, [_c('mt-button', {
    attrs: {
      "size": "large"
    },
    nativeOn: {
      "click": function($event) {
        _vm.sheetVisible = true
      }
    }
  }, [_vm._v("点击上拉 action sheet")]), _vm._v(" "), _c('mt-button', {
    attrs: {
      "size": "large"
    },
    nativeOn: {
      "click": function($event) {
        _vm.sheetVisible2 = true
      }
    }
  }, [_vm._v("不带取消按钮的 action sheet")])], 1), _vm._v(" "), _c('mt-actionsheet', {
    attrs: {
      "actions": _vm.actions
    },
    model: {
      value: (_vm.sheetVisible),
      callback: function($$v) {
        _vm.sheetVisible = $$v
      },
      expression: "sheetVisible"
    }
  }), _vm._v(" "), _c('mt-actionsheet', {
    attrs: {
      "actions": _vm.actions2,
      "cancel-text": ""
    },
    model: {
      value: (_vm.sheetVisible2),
      callback: function($$v) {
        _vm.sheetVisible2 = $$v
      },
      expression: "sheetVisible2"
    }
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7eda9676"}!./~/vue-loader/lib/selector.js?type=template&index=0!./example/pages/action-sheet.vue
// module id = 311
// module chunks = 0